'use strict';

/**
 * Updates inputs attributes with the input's actual value. This is
 * useful for when you need to move a DOM element to html and then back to a
 * DOM element again while retaining its values.
 */

module.exports = function($) {

  $.fn.swValsToAttrs = function() {
    var $this = $(this);
    $this.each(function () {
      var $this = $(this);

      if ($this.is("[type='radio']") || $this.is("[type='checkbox']")) {
        if ($this.prop('checked')) {
          $this.attr('checked', 'checked');
        } else {
          $this.removeAttr('checked');
        }

        return true;
      } 

      if ($this.is('select')) {
        $this.find(':selected').attr('selected', 'selected');

        return true;
      } 

      if ($this.is('textarea')) {
        $this.html($this.val());

        return true;
      } 

      $this.attr('value', $this.val());
    });
  };

};
